export default __webpack_public_path__ + "static/media/BoyPage1.54c9fc18.txt";